import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'separadorSequencia',
  standalone: true
})
export class SeparadorSequenciaPipe implements PipeTransform {

  transform(value: string | number): string {
    const strValue = value?.toString();

    if(!strValue || strValue.length < 5){
      return strValue;
    }
    const ano = strValue.substring(0, 4);
    const sequencia = strValue.substring(4);
    return `${sequencia}-${ano}`
  }
}
